import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.8);
  z-index: 1200; /* Acima do modal de Create */
  display: flex;
  justify-content: center;
  align-items: center;
  animation: ${fadeIn} 0.2s ease;
`;

export const Modal = styled.div`
  background: #222;
  width: 600px;
  max-width: 90%;
  max-height: 80vh;
  border: 1px solid #e6aa3a;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.8);
`;

export const Header = styled.div`
  padding: 15px 20px;
  border-bottom: 1px solid #444;
  display: flex;
  justify-content: space-between;
  align-items: center;

  h3 {
    margin: 0;
    color: #e6aa3a;
  }

  button {
    background: transparent;
    border: none;
    color: #fff;
    font-size: 24px;
    cursor: pointer;
    &:hover {
      color: #e6aa3a;
    }
  }
`;

export const SearchBar = styled.div`
  padding: 15px 20px;
  display: flex;
  gap: 10px;
  background: #1a1a1a;

  input {
    flex: 1;
    padding: 10px;
    border-radius: 4px;
    border: 1px solid #444;
    background: #333;
    color: #fff;

    &:focus {
      outline: none;
      border-color: #e6aa3a;
    }
  }

  button {
    padding: 0 20px;
    background: #e6aa3a;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-weight: bold;

    &:hover {
      background: #ffc300;
    }
  }
`;

export const List = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 10px 0;

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: #444;
    border-radius: 3px;
  }
`;

export const ListItem = styled.div`
  padding: 15px 20px;
  border-bottom: 1px solid #333;
  cursor: pointer;
  transition: background 0.2s;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:hover {
    background: #333;
  }

  .info {
    display: flex;
    flex-direction: column;
    gap: 4px;

    strong {
      color: #fff;
      font-size: 15px;
    }
    span {
      color: #999;
      font-size: 13px;
    }
    small {
      color: #e6aa3a;
      font-size: 12px;
    }
  }

  .arrow {
    color: #555;
    font-size: 20px;
  }
`;

export const Empty = styled.div`
  padding: 40px;
  text-align: center;
  color: #666;
`;
